"use strict";

angular.module('app.schedule.favoriteGame.favoriteGameDirective', [])
    .directive('favoriteGame', [
        function () {
            return {
                restrict: 'E',
                templateUrl: 'components/schedule/favoriteGame/favoriteGameView.html'            }
        }
    ]);


// WEBPACK FOOTER //
// ./app.v2/components/schedule/favoriteGame/favoriteGameDirective.js